'use client'

import { type ReactNode } from 'react'

import { cn } from '@/shared/lib'

type ListProps = {
  title: string
  children: ReactNode
}

export const List = ({ title, children }: ListProps) => (
  <div className="rounded bg-white px-5 py-6 shadow-[0_1px_7px_0_rgba(0,0,0,0.15)]">
    <p className="typo-headline3 mb-4 font-semibold text-black">{title}</p>
    <ul>{children}</ul>
  </div>
)

type ItemProps = {
  onClick: () => void
  children: ReactNode
  trailing?: ReactNode
}

export const Item = ({ onClick, children, trailing }: ItemProps) => (
  <li className="py-[10px] first:pt-0 last:pb-0">
    <button
      type="button"
      className={cn(
        'flex w-full items-center gap-2 text-left',
        trailing && 'justify-between',
      )}
      onClick={onClick}
    >
      <div className="flex min-w-0 items-center gap-2">{children}</div>
      {trailing}
    </button>
  </li>
)
